import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "@/utils/authUtils"; // Assuming you have a utility for fetching the token
import { baseApi } from "@/utils/baseApi";
import { API_ENDPOINTS } from "./apiEndPoints";
export const chatBotApiNew = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    sendChatMessage: builder.mutation({
      query: (formData) => ({
        url: API_ENDPOINTS.chat.sendMessage(),
        method: "POST",
        body: formData,
      }),
      transformResponse: (response) => {
        return response;
      },
      invalidatesTags: ["ChatBotNew"],
    }),
  }),
});

export const { useSendChatMessageMutation } = chatBotApiNew;
